"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var React = require("react");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/components/ContextualMenu");
var owa_mail_favorites_store_2 = require("owa-mail-favorites-store");
var FindFavorites_1 = require("./FindFavorites");
var owa_mail_find_favorites_store_1 = require("owa-mail-find-favorites-store");
var styles = require('./FindFavorites.scss');
var FindFavoritesContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(FindFavoritesContextMenu, _super);
    function FindFavoritesContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOpenFindFavoritesMenu = function () {
            _this.isFindFavoritesOpen = true;
            if (_this.findFavoritesControl) {
                // Focus on search box when the menu opens
                _this.findFavoritesControl.setFocusInSearchBox();
            }
        };
        _this.onHideFindFavoritesMenu = function () {
            _this.isFindFavoritesOpen = false;
            owa_mail_favorites_store_2.showFindFavoritesPicker(false);
            owa_mail_find_favorites_store_1.setFindText('');
        };
        _this.refFindFavoritesControl = function (ref) {
            _this.findFavoritesControl = ref;
            // The ref may fire after the onOpenFindFavoritesMenu callback happens, in which case we need to
            // trigger focus now
            if (_this.isFindFavoritesOpen) {
                _this.findFavoritesControl.setFocusInSearchBox();
            }
        };
        return _this;
    }
    FindFavoritesContextMenu.prototype.render = function () {
        var _this = this;
        if (!owa_mail_favorites_store_1.favoritesStore.favoritesViewState.shouldShowFindFavoritesPicker) {
            return null;
        }
        return (React.createElement(ContextualMenu_1.ContextualMenu, { target: this.props.anchorElement, directionalHint: 4 /* bottomLeftEdge */, directionalHintFixed: true, onMenuOpened: this.onOpenFindFavoritesMenu, onDismiss: this.onHideFindFavoritesMenu, className: styles.contextMenuContainer, items: [
                {
                    key: 'findFavorites_menu',
                    onRender: function () { return (React.createElement(FindFavorites_1.default, { key: 'findFavorites', ref: _this.refFindFavoritesControl })); },
                },
            ] }));
    };
    FindFavoritesContextMenu = tslib_1.__decorate([
        mobx_react_1.observer
    ], FindFavoritesContextMenu);
    return FindFavoritesContextMenu;
}(React.Component));
exports.default = FindFavoritesContextMenu;
//# sourceMappingURL=FindFavoritesContextMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/components/FindFavoritesContextMenu.js
// module id = 6274
// module chunks = 68